import ChartBuilder from './chart_builder'

export default {
  setup() {
    const defaultOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          grid: {
            display: false
          }
        },
        y: {
          beginAtZero: true
        }
      },
      plugins: {
        legend: {
          display: true,
          position: 'bottom',
          align: 'start',
          labels: {
            font: {
              size: 12
            },
            usePointStyle: true,
            boxWidth: 8
          }
        },
        tooltip: {
          backgroundColor: '#fff',
          bodyColor: '#00000099',
          bodyFont: {
            size: 14
          },
          bodyFontSize: 14,
          bodySpacing: 8,
          borderColor: '#cecece',
          borderWidth: 1,
          boxPadding: 8,
          mode: 'x',
          padding: 16,
          position: 'nearest',
          titleColor: '#5E5E5E',
          titleFont: { size: 12, weight: 'normal' },
          titleMarginBottom: 14,
          usePointStyle: true,
          callbacks: {
            title: function (context) {
              return context[0].label
            },
            label: function (context) {
              return `${context.dataset.label}: ${context.formattedValue}`
            },
            labelPointStyle: function (context) {
              return {
                pointStyle: 'circle',
                rotation: 0
              }
            }
          }
        }
      }
    }
    const data = JSON.parse(this.el.dataset.chartData)
    const options = JSON.parse(this.el.dataset.chartOptions || '{}')
    this.chart = new ChartBuilder(
      this.el,
      'line',
      data,
      defaultOptions,
      options
    ).chart
  },
  destroy() {
    this.chart?.destroy()
    this.chart = null
  },
  mounted() {
    this.setup()
  },
  updated() {
    ChartBuilder.refresh_data(this)
  },
  destroyed() {
    this.destroy()
  }
}
